import React from 'react';
import { ReactSortable } from "react-sortablejs";


class ProjetTagsComponent extends React.Component {
	constructor(props) {
		super(props);

		if ( props.value ) {
			for ( let i = 0; i < props.value.length; i++ ) {
				if ( !props.value[i].hasOwnProperty('id') )
					props.value[i].id = uniqid();
			}
		}

		this.state = { 
			items: props.value ?? [],
			label: '',
			color: '#000000',
		};
	}

	hexToHSL(H) {
		// Convert hex to RGB first
		let r = 0, g = 0, b = 0;
		if (H.length == 4) {
		  r = "0x" + H[1] + H[1];
		  g = "0x" + H[2] + H[2];
		  b = "0x" + H[3] + H[3];
		} else if (H.length == 7) {
		  r = "0x" + H[1] + H[2];
		  g = "0x" + H[3] + H[4];
		  b = "0x" + H[5] + H[6];
		}
		// Then to HSL
		r /= 255;
		g /= 255;
		b /= 255;
		let cmin = Math.min(r,g,b),
			cmax = Math.max(r,g,b),
			delta = cmax - cmin,
			h = 0,
			s = 0,
			l = 0;
	  
		if (delta == 0)
		  h = 0;
		else if (cmax == r)
		  h = ((g - b) / delta) % 6;
		else if (cmax == g)
		  h = (b - r) / delta + 2;
		else
		  h = (r - g) / delta + 4;
	  
		h = Math.round(h * 60);
	  
		if (h < 0)
		  h += 360;
	  
		l = (cmax + cmin) / 2;
		s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
		s = +(s * 100).toFixed(1);
		l = +(l * 100).toFixed(1);
	  
		return {H: h, S: s, L: l};
	}

	update() {
		updateTagsProjets(this.state.items);
	}

	addElement() {
		if ( this.state.label == '' ) {
			return;
		}
		let hsl = this.hexToHSL(this.state.color);
		let items = this.state.items;
		items.push({
			id: uniqid('tmp'),
			label: this.state.label,
			color: this.state.color,
			textcolor: hsl.L > .5 ? '#000' : '#fff',
		});
		this.setState({ items: items });
		this.update();
	}

	removeElement(index) {
        if ( window.confirm('Voulez-vous supprimer ce champ ?') ) {
            let items = this.state.items;
            items.splice(index, 1);
            this.setState({ items: items });
            this.update();
        }
	}

	changeLabel(value) {
		this.setState({ label: value });
	}

	changeColor(value) {
		this.setState({ color: value });
	}

	renderItem(item, index) {
		return (<div key={item.id} className="row align-items-center gx-2 mt-2">
            <div className="col-auto px-1 align-self-stretch d-flex align-items-center">
                <i className="grabber bi bi-grip-vertical px-2"></i>
			</div>
            <div className="col-auto">
				<span className="badge tag" style={{background:item.color, color:item.textcolor}}>{item.label}</span>
            </div>
			<div className="col-auto">
                <button type="button" className="btn-close" onClick={e => this.removeElement(index)}></button>
            </div>
		</div>);
	}

	render() {
		let items;
		if ( this.state.items.length ) {
			items = this.state.items.map( ( item, index ) => {
				return this.renderItem(item, index, null);
			});
		}

		return (
			<>
				<ReactSortable className="mb-3"
					list={this.state.items}
					setList={(newState) => { this.setState({ items: newState }, () => this.update() ) } }
					animation={150}
					handle=".grabber"
					ghostClass="_moving"
					fallbackOnBody={true}
					swapThreshold={0.65}
				>
					{items}
				</ReactSortable>
				<div className="row g-2 align-items-center">
					<div className="col">
						<input type="text" className="form-control" placeholder="Label" value={this.state.label} onChange={e => this.changeLabel(e.target.value)} />
					</div>
					<div className="col-auto">
						<input type="color" className="form-control form-control-color" title="Choisissez une couleur" value={this.state.color} onChange={e => this.changeColor(e.target.value)} />
					</div>
					<div className="col-auto">
						<button type="button" className="btn btn-outline-success" onClick={e => this.addElement()}><i className="bi bi-plus-lg"></i></button>
					</div>
				</div>
			</>
		);
	}
}

export default ProjetTagsComponent;